export default {
  close: 'Close',
  dataIterator: {
    pageText: '{0}-{1} of {2}',
    noResultsText: 'No matching records found',
    loadingText: 'Loading items...',
  },
  dataTable: {
    itemsPerPageText: 'Rows per page:',
    ariaLabel: {
      sortDescending: ': Sorted descending. Activate to remove sorting.',
      sortAscending: ': Sorted ascending. Activate to sort descending.',
      sortNone: ': Not sorted. Activate to sort ascending.',
    },
    sortBy: 'Sort by',
  },
  dataFooter: {
    itemsPerPageText: 'Items per page:',
    itemsPerPageAll: 'All',
    nextPage: 'Next page',
    prevPage: 'Previous page',
    firstPage: 'First page',
    lastPage: 'Last page',
  },
  datePicker: {
    itemsSelected: '{0} selected',
  },
  noDataText: 'No data available',
  carousel: {
    prev: 'Previous visual',
    next: 'Next visual',
  },
  calendar: {
    moreEvents: '{0} more',
  },
  fileInput: {
    counter: '{0} files',
    counterSize: '{0} files ({1} in total)',
  },
  observation: {
    accumulatedTemperature: 'Effective accumulated temperature',
    accumulatedTemperatureList: 'List of effective accumulated temperature',
    startDateCalculation: 'Start date of calculation',
    endDateCalculation: 'End date of calculation',
    lowerLimitTemperature: 'Lower limit temperature',
    registerAndEditAccumulatedTemperaturePoints: 'Registration/editing of calculating accumulated temperature points',
    period: 'Period',
    accumulatedLowerLimitTemperature: 'Accumulated lower limit temperature',
    deleteAccumulatedTemperatureLocation:
      'Are you sure you want to delete the accumulated temperature observation points of 「{fieldName}」?',
    soilMoisture: 'Soil moisture',
    soilTemperature: 'soilTemperature',
    precipitation: 'precipitation',
    soilMoistureList: 'List of soil moisture',
    maxRegisterCount: '（Up to {count}）',
    soilConditionVeryWet: 'Overdampness',
    soilConditionWet: 'Moist',
    soilConditionDry: 'Dryness',
    soilConditionVeryDry: 'Overdrying',
    drainage: 'Soil texture',
    registerAndEditSoilMoisturePoints: 'Registration/editing of soil moisture calculation points',
    soilMoistureConditionGood: 'Sandy Loam',
    soilMoistureConditionSlightlyBad: 'Clay Loam',
    soilMoistureConditionBad: 'Clay',
    soilMoistureConditionSandyLoam: 'Sandy Loam',
    soilMoistureConditionClayLoam: 'Clay Loam',
    soilMoistureConditionClay: 'Clay',
    deleteSoilMoistureLocation:
      'Are you sure you want to delete the soil moisture observation points in 「{fieldName}」?',
    deletedField: '< Field has been removed >',
    validateForStartDateBeforeYesterday: 'Start date must be at least one day in advance',
    validateForStartEndDateOrder: 'The end date must be later than the start date.',
    validateForStartEndDuration: 'Start and end dates must be within {day} days of each other',
    validateForStartNowDuration: 'The start date must be within {day} days of the present',
  },
  caster: {
    rtkInfo: 'RTK Correction Information',
    rtkLog: 'Communication Log',
    myBaseStationStatus: 'My Base Station Status',
    howToSetupRtkBase: 'When sending correction information from another company\'s product to "My Base Station"',
    howToSetupRtkRover: 'When receiving correction information from "My Base Station" with another company\'s product',
    host: 'Host',
    port: 'Port',
    mountpoint: 'Mount Point',
    derivedPassthroughLabel: ' (no conversion)',
    derivedPassthroughCaption: 'Streams the base station corrections as-is. Use this normally',
    derivedMsm4Label: ' (compatibility)',
    derivedMsm4Caption: 'Converted to MSM4: for receivers unstable with the latest format (e.g. MSM7)',
    derivedLegacyLabel: ' (for older receivers)',
    derivedLegacyCaption: 'Converted to legacy 1004/1012: GPS+GLONASS only',
    derivedNote:
      'If corrections are not received or do not FIX, try _MSM4 / _LEGACY. These outputs may not be available when a non-AgriBus base station is connected.',
    messageTypesTitle: 'Broadcast message types (technical details)',
    messageTypesIntro:
      'If a receiver manufacturer asks which RTCM messages the base station broadcasts, refer to the list below for the mount point you connect to.',
    messageTypesPassthrough:
      'Streams the base station output as-is. For our AgriBus-GMiniR base stations: RTCM 3.3 / MSM4+MSM7 (1074/1077 GPS, 1084/1087 GLONASS, 1094/1097 Galileo, 1124/1127 BeiDou) every second, plus 1005 (station position), 1008 (antenna info) and 1230 (GLONASS code-phase biases). For third-party base stations this depends on the device settings',
    messageTypesMsm4:
      'Normalized to RTCM 3.3 / MSM4: 1074 (GPS), 1084 (GLONASS), 1094 (Galileo), 1114 (QZSS), 1124 (BeiDou) every second (only constellations the base station tracks), plus 1006, 1033 and 1230 every 5 seconds',
    messageTypesLegacy:
      'Legacy format (RTCM 3.1 style): 1004 (GPS L1/L2) and 1012 (GLONASS L1/L2) every second, plus 1006 and 1008 every 5 seconds (1033/1230 are not sent). Observation time tags are aligned to whole seconds, so receivers that expect whole-second time tags can also be used',
    baseStation: 'My Base Station',
    rover: 'Rover',
    userId: 'User ID',
    ntripUserId: 'Ntrip User ID',
    ntripPassword: 'Ntrip Password',
    showCaption: 'Show',
    statusTab: 'Status',
    qualityTab: 'Quality',
    mapTab: 'Map',
    logTab: 'Connection Log',
    settingsTab: 'Settings',
    baseShort: 'Base Station',
    casterServer: 'Caster Server',
    roverShort: 'Rover',
    receiving: 'Receiving',
    stale: 'Stalled',
    noConnection: 'Not Connected',
    lastReceivedAt: 'Last received',
    disconnectedAt: 'Disconnected',
    summaryTitle: 'Base Station Reception',
    lastSnapshotNote: 'Last values before disconnect',
    noStatsData: 'No data received from the base station',
    bytesRate: 'Data Rate',
    messagesPerSecond: 'Messages',
    epochInterval: 'Epoch Interval',
    uptime: 'Connected Time',
    decodeErrors: 'Decode Errors',
    basePosition: 'Base Position',
    antenna: 'Antenna',
    satellites: 'Satellites',
    signals: 'Signals',
    meanCnr: 'Mean C/N0',
    msgType: 'Message',
    msgCount: 'Count',
    msgInterval: 'Interval',
    msgLastSeen: 'Last received',
    cnrChart: 'Mean C/N0 (dB-Hz)',
    satsChart: 'Satellites',
    rateChart: 'Data rate (bytes/s)',
    epochChart: 'Epoch interval (ms)',
    noHistoryData: 'No history data yet',
    noTrackData: 'No rover GGA records',
    baseline: 'Baseline',
    fixQuality: 'Fix quality',
    ggaPoints: 'Recorded points',
    logBaseTitle: 'Base Station Connections',
    logRoverTitle: 'Rover Connections',
    startAt: 'Start',
    endAt: 'End',
    inSession: 'Connected',
    userAgentLabel: 'Client',
    logNote: 'Shows records from the last 24 hours',
  },
  print: {
    field: {
      fillSetting: 'Fill in the field',
      backgroundWhiteColorSetting: 'White background',
      backgroundNoColorSetting: 'No background',
      printText: 'Printing',
      showFieldName: 'Show field name',
    },
  },
  sortOptions: {
    title: 'Sort by',
    field: {
      name: 'Field name',
      createdAt: 'Registration date',
      lastModifiedDateTime: 'Modified date',
    },
  },
  fieldElevation: {
    title: 'Height Map',
    cantBuildBecauseNoTask: 'The work history does not exist, so it is not possible to create a height map.',
    nowBuilding: 'Preparing... (Depending on the area of the field, it may take some time to create.)',
    updatedAt: 'Created date',
    meshSize: 'Mesh size',
    taskFetchLimit: 'Data volume',
    taskDateRange: 'Scope',
    taskPointCount: 'Working point count',
    editButton: 'Edit',
    createButton: 'Create',
    needStandardPlan: 'Height Map requires the Standard Plan.',
    taskFetchLimitHint: 'If there is no difference in height, increase it. If there is a lot of noise, reduce it.',
    creationFailedMessage: 'Creating Height Map failed.',
    gnssStatus: 'GNSS status',
    elevationRange: 'Elevation range',
    optionSetting: 'Option setting',
    minValue: 'Minimum value',
    maxValue: 'Maximum value',
    minIgnoreCaption: 'Elevations below this value are ignored',
    maxIgnoreCaption: 'Elevations above this value will be ignored',
    minValueNeedError: 'Please set a minimum value',
    maxValueNeedError: 'Please set the maximum value',
    minValueRangeError: 'Minimum value must be less than maximum value',
    maxValueRangeError: 'Maximum value must be greater than minimum value',
    invalidOptionSettingError: 'Invalid option setting specified',
    dateRangeInput: 'Date range',
    oldestTaskDateInput: 'Start date',
    newestTaskDateInput: 'End date',
  },

  navi: {
    GeneralMainSettingMenuGnssSource: 'GNSS Source',
    GeneralMainSettingGnssSourceInternal: 'Internal',
    GeneralMainSettingGnssSourceGPlus: 'AgriBus-G+',
    GeneralMainSettingGnssSourceG2: 'AgriBus-G2',
    GeneralMainSettingGnssSourceGMini: 'AgriBus-GMini',
    GeneralMainSettingGnssSourceGMiniR: 'AgriBus-GMiniR',
    GeneralMainSettingGnssSourceUsb: 'USB',
    GeneralMainSettingGnssSourceBluetooth: 'Bluetooth',
    GeneralMainSettingGnssSourceTcpPort: 'TCP Port',
    GeneralMainSettingGnssSourceNtripClient: 'Ntrip Client (Trimble, Topcon)',
    GeneralMainSettingGnssSourceVirtual: 'Virtual',
  },

  ValidationTextRequired: 'Required',
  ResetPasswordTitle: 'Start Resetting Password',
  ResetPasswordButton: 'Start Resetting',
  ResetPasswordDescription: 'You will be receive a mail contains a password reset link.',
  ValidationBadEmail: 'Bad Email Address',
  ChangePasswordButton: 'Change Password',
  CreatePasswordButton: 'Create a password',
  UnitTitle: 'Unit',
  UnitMetric: 'Metric',
  UnitImperial: 'Imperial',
  UnitJpUnitsOfArea: 'Japanese Units of Area',
  UnitThUnitsOfArea: 'Thai Units of Area',
  NickNameHint: 'Your Nick Name',
  SendMeNews: 'Send me news.',
  FreePlanDisplayName: 'Free Plan',
  StandardPlanDisplayName: 'Standard Plan',
  ChangePasswordTitle: 'Change Password',
  CreatePasswordTitle: 'Create Password',
  CurrentPasswordHint: 'Current Password',
  NewPasswordHint: 'New Password',
  SignInButton: 'Log in',
  ToResetPasswordButton: 'Forgot Password',
  DocFormFieldDetailFieldNameHint: 'Field Name',
  DocFormTaskRecordDetailFieldNameHint: 'Task Record Name',
  DocFormTaskRecordDetailDescriptionHint: 'Description',
  DocFormTabNameTaskRecordList: 'Task Records',
  DocFormTabNameRefLineList: 'Guidance Lines',
  DocFormTabNameGridPointsList: 'Grid Points',
  DocFormTabNameFieldList: 'Fields',
  DocFormFieldRegisteredDateFormatBase: 'Registered: {createDate}',
  DocFormMenuItemSignOut: 'Log out',
  DocFormFieldDetailDescriptionHint: 'Description',
  StandardPlanIsNeededDialogMessage: 'Subscription of Standard Plan is needed to use this function.',

  SelectPlanDialogTitle: 'Select Plan',
  SelectPlanDialogRecommend: 'Recommended',
  SelectPlanDialogYearPlan: 'Annual plan',
  SelectPlanDialogYearPlanGreatValue: '(Discount for 2 months)',
  SelectPlanDialogYearMonth: 'Monthly plan',
  StandardPlanPriceForMonthBatch: 'Annual fee',
  StandardPlanPricePerMonth: '/Month',
  StandardPlanPricePerYear: '/Year',
  StandardPlanPriceForYearNotice: '* Payment for 12 months',
  SelectPlanSubscribeYear: 'Start trial for 30 days',
  SelectPlanSubscribeMonth: 'Start trial for 30 days',
  selectPlanDataViewNote:
    '* If you do not resume your subscription within about one month after cancellation, data recorded before the cancellation will no longer be displayed (applies from October 1, 2026). Please export any data you need while your subscription is active.',

  DefaultRefLineTypeStraight: 'Straight',
  DefaultRefLineTypeCurved: 'Curved',

  customSelectAll: 'Select All',
  customUnSelectAll: 'Un-Select All',

  customRegistration: 'Registration',
  customUpdate: ' Update',
  customSearch: 'Search',
  customDelete: 'Delete',
  customAllow: 'Allow',
  customDeny: 'Deny',
  customDefault: 'Default',
  customSelected: 'Selected',
  customSelectThis: 'Select this',

  customArea: 'Area',

  customNotAvailable: 'Not available',
  customEdit: 'Edit',
  customCancel: 'Cancel',
  customNone: 'None',
  customClose: 'Close',
  customFieldDrawHint:
    'Click the map to add field vertices, then press the check button to finish (undo button / Backspace removes the last point)',
  customBack: 'Back',
  customRefresh: 'Refresh',

  customUpload: 'Upload',

  customPriceIncludingTax: 'Price including tax',
  customPay: 'Pay',
  customCancelContract: 'Cancellation',

  customConfirmReally: 'Are you really sure?',

  customRememberMe: 'Remember me',
  customLogin: 'Log in',
  customNowLoggingIn: 'Logging in...',
  customEmail: 'Email',
  customPassword: 'Password',
  customUser: 'User',
  customUserSettings: 'User Settings',
  customSentEMailMessage: 'Sent email.',
  customNewPasswordReInput: 'Verify password',
  customValidationPasswordMinLength: 'Password must be at least {length} characters',
  customValidationPasswordMaxLength: 'Too long',
  customValidationPasswordNotMatch: "Passwords don't match",
  customChangePasswordSuccess: 'Your password changed.',
  customGoToLoginPageTitle: 'Return to Login Page',
  customYouDontHaveAccount: 'Not a user?',

  customRegisterAgriBusWeb: 'Sign Up for AgriBus-Web',

  customChange: 'Change',
  customLanguage: 'Language',
  customSaveAction: 'Save',
  customSaveSuccess: 'Saved',

  customAddAction: 'Add',

  customPlan: 'Plan',
  customPlanExpirationDate: 'Expiration date: {expirationDate}',
  customPlanDescription: 'In order to change your plan, it is necessary to do from AgriBus-NAVI(Android application).',
  customPlanOnly: 'This feature requires a standard plan',

  customDetail: 'Detail',

  customDatePickerNullAlert: 'Please select a date first',
  customTaskNotFound: 'Task not found.',
  customTaskNotFoundAtDate: 'Task not found at {date}.',
  customErrorInitTasksFreePlan: 'In Free plan, it is limited to tasks up to two days.',
  customErrorInitTasksNoTasks: 'Do "Synchronize Data" by AgriBus-NAVI when you cannot see any tasks.',
  customErrorInitFieldsNoFields: 'You didn\'t "Synchronize Data" by AgriBus-NAVI or NO fields were registered.',

  customColored: 'Colored',
  customHeight: 'Height',
  customHeightMap: 'Height Map',
  customSpeed: 'Speed',

  customDate: 'Date',
  customWorkWidth: 'Work Width',
  customWorkedArea: 'Worked Area',
  customOverlappedArea: 'Overlapped Area',
  customTaskRecordEfficiency: 'Efficiency',
  customDistance: 'Distance',
  customWorkedTime: 'Worked Time',
  customAverageSpeed: 'Average Speed',
  customWorker: 'Worker',

  customDocFormTaskRecordDistanceOfFormatBase: '{distance} (Av. {speed})',
  customDocFormTaskRecordWorkedAreaPercentageFormatBase: '{percentage}% of {fieldArea}',
  customDocFormTaskRecordWorkedAreaInfoFormatBase: '{areaPercentageText}, {efficiencyText}/h',

  customPageSuffix: 'page(s)',
  customDisplayCount: 'Displayed results',
  customTotalCount: 'Total {count}',

  customListingModeSelf: 'Only myself',
  customListingModeAll: 'Including following',

  customIconSettings: 'Icon Setting',

  customAccountHeader: 'ACCOUNT',
  customConnectionHeader: 'CONNECTIONS',
  customConnectionTitle: 'Connections',
  customFollowRequest: 'Follow Request',

  customFollow: 'Follow',
  customUnfollow: 'Unfollow',
  customFollowing: 'Following',
  customFollower: 'Followers',

  customHaveNoFollowings: 'You have not followed anyone',
  customHaveNoFollowers: 'You have no followers',

  customInbox: 'Inbox',
  customOutbox: 'Outbox',

  customInboxEmpty: 'Empty',
  customOutboxEmpty: 'Empty',
  customSendFollowRequest: 'Send Follow Request',
  customSendFollowRequestMessage: 'A follow request has been sent',

  customFollowRequestSelfRequestError: "You can't send follow request to yourself",
  customAllowFollowRequest: 'You allowed follow request from {fromNickname}',
  customUnfollowMessage: 'Unfollowing completed.',

  customUpdatedIconMessage: 'Your icon is updated',
  customIconNowSelected: 'Now selected',
  customIcon: 'Default',
  customIconSettingsDescription: 'We recommend that you set your own icon.',
  customIconChangeToIcon: 'Change to default',
  customGravatarIcon: 'Gravatar',
  customIconSettingsGravatarDescription: "If you have Gravatar's icon, it is useful to choose this.",
  customIconChangeToGravatar: 'Select this',
  customCustomIcon: 'Custom',
  customIconSettingsCustomDescription: 'You can set your favorite photos. Prepare JPEG or PNG file.',
  customIconChangeToCustom: 'Select this',
  customIconReUpload: 'Upload again',

  customTemperature: 'Temperature',
  customHumidity: 'Humidity',
  customWind: 'Wind',
  customPressure: 'Pressure',
  customSunrise: 'Sunrise',
  customSunset: 'Sunset',

  customShowAllCropsDescription: 'Show all',
  customShowCurrentCropsDescription: 'Only current',

  customProduct: 'Crop',
  customProductsNotFound: 'No crops',

  customColor: 'Color',
  customYear: 'Year',
  customCrop: 'Crop',
  customCropVariety: 'Variety',
  customDeleteCropConfirmationMessage:
    '{cropYear} {cropName} {cropVariety} will be deleted. Are you sure ? (This will be deleted all associated data.)',

  customOperationType: 'Operation',

  customFilter: 'Filter',
  customOutOfField: 'Out of field',

  customBillingPlan: 'Pricing Plan',
  customBillingAndPayment: 'Billing',
  customBillingMethod: 'Payment Methods',
  customBillingExistingCard: 'Existing Cards',
  customBillingAddNewCard: 'Add New Card',
  customBillingMethodConfirm: 'Please confirm payment method',
  customBillingHistory: 'Billing History',

  customCreditCard: 'Card',
  customCreditCardLast4: 'ending in',
  customCreditCardNameOnCard: 'Name on Card',
  customCreditCardInfo: 'Card Info',
  customCreditCardAddCard: 'Add Card',
  customCreditCardAddCardCaution1:
    'Your card will not be charged at this time, but will be set as the default for future charges.',
  customCreditCardAddCardCaution2:
    'If you would like to pay your bill, please contact contact@agri-info-design.com before registering your card.',
  customCreditCardNoCard: 'No Cards',
  customCreditCardDeleteFailure: 'Card deregistration was failed.',

  customMyProducts: 'My Products',
  customMyProductsList: 'List of products',

  customMyProductProduct: 'Product',
  customMyProductProductNumber: 'Product number',
  customMyProductDataPlan: 'Data plan',
  customMyProductDataPlanSubscribe: 'Subscribe',
  customMyProductDataPlanSubscribeSuccessMessage: '3G communication of {productNumber} will be effective shortly.',
  customMyProductDataPlanExpiredMessage: 'Expired at {expiredDate}',
  customMyProductDataPlanCancelConfirmationMessage:
    'If you cancel this plan, 3G communication will be terminated. Also, even if the period remains, the difference can not be refunded. However, even once it is canceled, it is possible to re-sign the plan again. Are you really sure?',

  customRealTime: 'Real Time',
  customRealTimeSettings: 'Real Time Settings',
  customModel: 'Model',
  customSystemVersion: 'System Version',
  customWebMarkerIcon: 'Icon',
  customWebMarkerSetting: 'Marker Setting',
  customWebMarkerName: 'Marker Name',
  customWebMarkerColor: 'Marker Color',

  customRealtimeChooseYourDevice: 'Choose your device',
  customRealtimeDeviceNotActive: 'Not Active',
  customElevation: 'Height',
  customGnss: 'GNSS',
  customSatellites: 'Satellites',

  customFirmwareVersion: 'Firmware Version',
  customHasFirmwareUpdate: 'Update Available',
  customFirmwareDownloadMessage: 'A new version {newestFirmwareVersion} is available.',
  customDownload: 'Download',

  customFieldRegistration: 'Field registration',
  customFieldCreateWithMapTitle: 'Create Field on the Map',
  customFieldCreateWithMapTitleDescription: 'Create a new field on the map',
  customFieldCreateWithMapButton: 'Create',

  customFieldCreateWithMapFieldName: 'Field Name',
  customFieldCreateWithMapLoadingMap: 'Loading map...',
  customFieldCreateWithMapCreate: 'Create',
  customFieldCreateWithMapCreateFinishedMessage: 'Created field {fieldName}',
  customFieldCreateWithMapCreateErrorMessage: 'Failed to create field　{fieldName}',
  customFieldCreateWithMapNoFieldMessage: 'Create a field on the map',
  customFieldCreateWithMapNoFieldNameMessage: 'Enter field name',
  customFieldCreateWithMapTooManyFieldsMessage: 'One field can be created',

  customFieldUploadTitle: 'Upload KML/Shapefile',
  customFieldUploadMessage: 'Upload your KML/KMZ file or Shapefile.',
  customFileUploadShapefileDescription:
    'Shapefile ZIP Archive must contain at least one of each of following file types.',
  customFieldUploadFileInput: 'Please file select.',

  customFileUploadShpDescription: '.shp : Geometry',
  customFileUploadShxDescription: '.shx : Geometry Index',
  customFileUploadDbfDescription: '.dbf : Attributes Database',
  customFileUploadPrjDescription: '.prj : Geographic Coordinate Info.',
  customFileUploadPrjCaution: '.prj is necessary to read coordinate information correctly.',

  customFileUploadTextEncodingDescription: 'Please change this value if the attribute name is corrupted.',
  customFileUploadAttributeNameForFieldName: 'Attribute name used as field name',
  customFileUploadFieldImportStart: 'Start importing fields ({count})',
  customFileUploadImportCheckTitle: 'Import',
  customFileUploadFieldImportStartedMessage:
    'Importing fields has started. It may take several minutes if many fields.',
  customFieldUploadErrorMessage: 'Can not read uploaded file',

  customFieldThisFieldName: 'Field "{fieldName}"',
  customFieldUnknownFieldName: 'This field',
  customFieldNoName: 'No Field',

  customFieldDeleteAlertWithTask:
    'There are {count} task(s) in {fieldName}. If you delete this, field information of these tasks are lost. Are you really sure?',
  customFieldDeleteAlertWithoutTask: 'Are you sure you want to delete {fieldName}?',

  customTextEncoding: 'Encoding',

  customFieldImportFinishedMessage: 'Importing {count} fields has finished.',
  customFieldImportErrorMessage: 'Importing fields failed.',

  customFieldCount: 'Number of fields: {count}',

  customExport: 'Export',
  customTaskExport: 'Exporting Tasks',
  customTaskWhatIsAgriBusFormat: 'AgriBus format is TAB delimited text, so it is easy to process.',
  customTaskNowDeveloping: 'In development',
  customTaskNowDevelopingDescription: 'Soon you will be able to output in other formats.',
  customTaskStartExporting: 'Start Exporting',
  customTaskNowExporting: 'Now Exporting...',
  customTaskDownloadReady: 'Ready to download',

  // New
  customFieldHeader: 'Fields',
  customDarkMode: 'Dark Mode',
  customNewRegistration: 'New Registration',
  customCreateNew: 'Create',
  customImport: 'Import',
  customListDisplay: 'List Display',
  customCardDisplay: 'Card Display',
  customCalendarDisplay: 'Calendar Display',
  customFieldsList: 'Fields List',

  customPleaseSignUpFromAndroidApplication:
    'Please Sign up from Android application <span class="aid-logotype">AgriBus-NAVI</span>',
  customWhatIsAgribusNAVI: 'What is <span class="aid-logotype">AgriBus-NAVI</span>',
  customAgriBusNAVIDescription:
    '<span class="aid-logotype">AgriBus-NAVI</span> is a GPS guidance system to mount on agricultural machinery such as tractors, combines and ' +
    'self-propelled sprayers to help with straight line tasks in the field. Checking the display while ' +
    'driving will enable the creation of straight and evenly spaced lines in large fields.',
  customProductDetails: 'Product Details',

  aid: {
    calendar: { month: 'Month', week: 'Week', day: 'Day', fourDays: '4 days' },
  },

  customTaskFilterAllSelect: 'All work',

  customTaskFilterGetError: 'Failed to get filter information',
  customTaskFilterPostError: 'Failed to register filter information',
  customTaskFilterPutError: 'Failed to update filter information',
  customTaskFilterDeleteError: 'Failed to delete filter information',

  customTaskFilterPostSucceed: '"{filtername}" Registered',
  customTaskFilterPutSucceed: '"{filtername}" The has been updated',
  customTaskFilterSetDefault: 'Set "{filtername}" as the default filter',
  customTaskFilterDeleteSucceed: 'Filter information has been deleted',

  customTaskFilterSelectCheckError: 'The corresponding filter does not exist. Please select a filter',
  customTaskFilterDuplicateCheckError: 'Duplicate filter name',
  customTaskFilterNotEnteredCheckError: 'No filter name entered',

  customTaskFilterStringNarrowing: 'String narrowing',
  customTaskFilterMakeDefault: 'Always use this filter',
  customTaskFilterName: 'Filter name',
  customTaskFilterDeleteMsg: '"{filtername}" Do you want to delete?',

  customTaskFilterDialogTitle1: 'Filter work history',
  customTaskFilterDialogTitle2: 'Apply saved filter settings',
  customTaskFilterCreateNew: 'Create a new filter setting',
  customTaskFilterEdit: 'Editing a filter',
  customTaskFilterSetting: 'Filter setting',
  customTaskFilterCurrent: 'Current Filter',
  customTaskFilterNoTasksError: 'Due to the setting of the filter "{filtername}", the number of displayed items is 0.',
  customTaskFilterAreaZeroHidden: 'Excluding work with zero work area',
  customTaskFilterDistanceUnderTenHidden: 'Excludes work with less than 10m (10.936yd) of mileage',
  customTaskFilterNoField: 'No field',
  customTaskFilterNoCrop: 'No crop',
  customTaskFilterOutOfFieldHidden: 'Excludes task history outside the field',

  customSimpleSignUpNow: 'Registering ...',
  customSimpleSignUpSuccess: 'An email has been sent to complete registration. Please check your mailbox.',
  customEnterpriseInviteSuccess: "I've sent you an email invitation",
  customSimpleSignUpFailed: 'Registration failed.',
  customSimpleSignUpUserAlreadyExists: 'There is a problem with your email address',
  customSimpleSignUpServerError: 'An error occurred during the registration process',

  customDateFilterStartDate: 'Filter start date',
  customDateFilterEndDate: 'Filter end date',
  customDateFilterCalendarType: 'Calendar type',
  customDateFilterCalendarTypeDate: 'Day',
  customDateFilterCalendarTypeMonth: 'Month',
  customDateFilterSetBotton: 'Set',
  customDateFilterRangeError: 'Start date is later than end date.Please select a date again.',

  customCurrency: 'Currency',

  customBillingCurrencyJPY: 'Japanese Yen',
  customBillingCurrencyUSD: 'U.S. dollar',
  customBillingPurchase: 'Try a free trial for 30 days',
  customBillingPurchaseWithoutTrial: 'Upgrade',

  customBillingPlanInfo: 'Plan Info.',
  customBillingNowPlan: 'Your Plan',
  customBillingTrial: 'Trial',
  customBillingCancellation: 'Cancellation',
  customBillingContractPeriod: 'Contract period',
  customBillingAmount: 'Amount',
  customBillingAlertMustRegisterCard: 'In order to purchase, you need to register a credit card in advance.',
  customBillingMessageUnsubscribe: 'Paid plan has been cancelled',
  customBillingMessageSubscribe: 'Thank you for your purchase',
  customBillingMessageUnSubscribeGoogle:
    'You are currently paying on Google Play Store. Please Cancel the subscription at Google Play Store.',
  customBillingReceipt: 'Invoices / Receipts',
  customBillingMessageCancelStandardPlan:
    'If you cancel your paid plan, you will still be able to use the service for the period you have paid for. If I cancel here, I will automatically be put on the free plan after {date}, is this still acceptable?',
  customBillingMessageCancelTrial:
    'You are currently in the trial period, but if you cancel at this point, you will immediately be returned to the free plan. You can sign up for a new paid plan after the cancellation, but please note that the trial period will not be accrued in that case.',
  customBillingStandardDescription:
    "One month free with paid annual plan; take advantage of all features, including AgriBus-Web's indefinite data storage and real-time vehicle location display, AgriBus-NAVI's curve guidance and information tray, and more!",

  customBillingMenu: 'Management of your plan',
  customBillingMore: 'Find out more',

  customAdRow1_1: 'A data revolution in farming',
  customAdRow1_2: 'with Standard Plan.',

  customAdRow2_1: '3 benefits',
  customAdRow2_2: 'Unlimited storage and export of data',
  customAdRow2_3: 'Vehicle position real-time display',
  customAdRow2_4: 'Using AgriBus-Caster',

  customAdRow3_1: '3 benefits',
  customAdRow3_2: 'Add height difference, running speed, etc. to Task Records',
  customAdRow3_3: 'Save and recall guidance baseline',
  customAdRow3_4: 'Apply curve guidance',

  customOAuthMessage: 'During the authentication...',
  customGoogleOAuthBtn: 'Login with Google',
  customGoogleOAuthSignUpBtn: 'Sign up with Google',
  customOAuthError: 'Error in OAuth authentication process',
  customOAuthGetUserInfoError: 'An error occurred while getting OAuth information',
  customOAuthServerError: 'An error occurred in the OAuth credential registration process',
  customOAuthFailed: 'OAuth authentication failed',

  customToBillingPage: 'To the standard plan purchase screen',
  customTasksListFreePlanMsg:
    'In the free plan, the work history is displayed only for 2 days. By subscribing to the standard plan, you can have an unlimited storage period.',

  customEnterprise: 'Enterprise',
  customEnterpriseSetting: 'Enterprise Settings',
  customEnterpriseManagement: 'Enterprise Management',
  customWhatIsEnterprise: 'What is AgriBus-Web Enterprise?',
  customEnterpriseRegistration: 'Sign up for the Enterprise Plan',
  customPleaseContinueToRegisterForEnterprise:
    'Please continue the registration process for AgriBus-Web Enterprise from the email you received.',
  customPleaseInputOrganizationName: 'Enter the name of your organization.',
  customEnterpriseName: 'Enterprise Name',
  customMaxOfMemberThisMonth: 'Maximum number of members this month',
  customExpectedPaymentAmountForThisMonth: 'Estimated payment amount for this month',
  customDateOfPayment: 'Date of payment',
  customPaymentHistory: 'Payment History',
  customEditEnterpriseName: 'Edit Enterprise Name',
  customOrganization: 'Organization',
  customOrganizationName: 'Organization name',
  customAdministrator: 'Administrator',
  customOrganizationList: 'Organization Chart',
  customNewOrganization: 'Creating a new organization',
  customCreateOrganization: 'Create an organization',
  customEditOrganizationName: 'Edit organization name',
  customTeam: 'Team',
  customTeamList: 'Team List',
  customMyTeam: 'My Team',
  customMyTeamList: 'My Team List',
  customNewTeam: 'Creating a new team',
  customTeamName: 'Team Name',
  customCreateTeam: 'Create a team',
  customRemoveFromTeam: 'Removed from the team',
  customEditTeam: 'Team Edit',
  customMember: 'Member',
  customMemberName: 'Member name',
  customAddNewMember: 'Add a member',
  customNumberOfMember: 'Number of members',
  customInviteMembers: 'Invite members',
  customSendInvitationEmail: 'Send invitation email',
  customPleaseEnterTheNameOfTheMember: 'Please enter the names of the members you are inviting',
  customMemberList: 'Member List',
  customEditMember: 'Edit Member',
  customInviting: 'During an invitation',
  customRestrictFollow: 'Follow restriction',
  customPermission: 'Access rights',
  customPermissionName: 'Access authorisation name',
  customRoleName: 'Role name',
  customAction: 'Action',
  customIndividualCreation: 'Individual Creation',
  customConfirmTeamDeletion: 'May I remove this team?',
  customConfirmMemberRemovalFromTeam: 'May I remove this member from the team?',
  customSelectTeamsForMemberToJoinDialogTitle: 'Select teams the member will join',
  customSelectTeamsForMemberToJoinDialogOK: 'Add to the selected teams',
  customSelectMembersAddToTeamDialogTitle: 'Please select members to join the team',
  customSelectMembersAddToTeamDialogOK: 'Add the selected members',
  customFollowMembersDialogTitle: 'Please select members to follow',
  customFollowMembersDialogOK: 'Follow the selected members',
  customTeamFollowSelectDialogTitle: 'Please select teams to follow',
  customTeamFollowSelectDialogOK: 'Follow the selected teams',
  customPleaseConfirm: 'Please check.',
  customEnterpriseSignUpForPleaseConfirmDescription1:
    'The user with the specified email address is on the Standard or Enterprise plan.',
  customEnterpriseSignUpForPleaseConfirmDescription2:
    'If you have a Standard plan, please sign up for an Enterprise plan after you have cancelled it.',
  customEnterpriseSignUpForFreePlanDescription:
    'Users with the specified email address are on a free plan. May I switch to the Enterprise plan?',
  customEnterpriseSignUpForStandardPlanDescription:
    'The user with the specified email address has cancelled the Standard plan, but it is still active. Do you want to switch to the Enterprise plan? (Please note that if the user still has payment for the Standard plan, they will be charged for both the Standard and Enterprise plans.)',
  customAddFollowMembers: 'Add a follow member',
  customAddFollowTeams: 'Add a follow team',
  customBillingMaxMember: 'Maximum number of members',
  customCreditCardRegistration: 'Credit Card Registration',
  customNext: 'Next',
  customGoBackOneStep: 'Back to the previous one',
  customRestriction: 'Restriction',
  customMemberSuspension: 'Are you sure you want to stop using this member?',
  customResumeMemberUsage: 'Are you sure you want to resume using this member?',
  customRestart: 'Restart',
  customSuspended: 'Suspended',
  customAddToExistingTeam: 'Add to the team',
  customFollowFunction: 'Follow function',
  customAllowToAddAndRemoveFollow: 'Allow to add and remove follow',
  customAllowToAddAndRemoveFollowDescription: 'This member is not allowed to add or remove followers themselves.',
  customNotAllowToAddAndRemoveFollow: 'Not allow to add and remove follow',
  customNotAllowToAddAndRemoveFollowDescription: 'This member is free to add and remove followers.',
  customEnterprisePlanDisplayName: 'Enterprise Plan',
  customPricePerMember: 'Price per member.',
  customPerMember: 'Per member',
  customNotesOnPlanSelection: 'The amount billed is the maximum number of members in the billing month x unit price.',
  customDueDateForFirstRepayment: 'Due date for first repayment',
  customEnterprisePlanStart: 'Start',
  customUnsubscribeFromEnterprise: 'Unsubscribe from the Enterprise Plan',
  customReturnAgriBusWeb: 'Return to Agri-Bus Web',
  customAboutCreditCardPayment: 'About credit card payment',
  customClickHereUnsubscripbeFromEnterprise: 'Click here to unsubscribe from the Enterprise Plan.',
  customEnterpriseWithdrawText1:
    'If you cancel your membership, your current months bill will be the last bill and there will be no further payments.',
  customEnterpriseWithdrawText2:
    'We will continue to develop each AgriBus series product in the future, so if you have a chance, please take a look again.',
  customEnterpriseWithdrawText3:
    'We would like to thank you for using each of the AgriBus series products, even if it was only for a moment. Thank you for your interest in our products.',
  customErrorEnterpriseWithdraw: 'You failed to cancel your Enterprise plan. Please try again.',
  customGuidanceInterval: 'Guidance Interval',
  customWorkingWidth: 'Working Width',
  customRefLineLength: 'Guidance Line Length',
  customRefLine: 'Guidance Line',
  customExportRefLine: 'Export Guidance Line',
  customDirecton: 'Direction',
  customShowTaskDetailError:
    'There is no work history, it may have been out of sync with AgriBus-NAVI or it may have been deleted.',
  customFileUploadAttributeNameForRefLineName: 'Name of attribute to be used as a Guidance Line',
  customFileUploadRefLineImportStart: ' Start capturing {count} Guidance Lines',
  customFileUploadShapefileDescriptionForRefLines:
    'The Shapefile requires a zip archive (compressed) file for the following files only',
  customFileUploadShpDescriptionForRefLines: 'Swaths.shp (Topographical information)',
  customFileUploadShxDescriptionForRefLines: 'Swaths.shx (index information)',
  customFileUploadDbfDescriptionForRefLines: 'Swaths.dbf (attribute information)',

  customRefLineImportFinishedMessage: 'We have succeeded in capturing {count} Guidance Lines',
  customRefLineImportErrorMessage: 'Failed to capture the Guidance Lines',
  customRefLineAddTitle: 'New Guidance Line Registration',
  customRefLineImportTitle: 'Uploading Shapefile',
  customRefLineImportText: 'Upload your Shapefile',
  customRefLineImportText2: 'Only Guidance Lines output from the Trimble CFX-750 can be imported.',
  customRefLineCreateTitle: 'Create a Guidance Line on the map',
  customRefLineCreateText: 'Create a Guidance Line on the map',
  customRefLineUploadTitle: 'Uploading Guidance Line',
  customRefLineNameHint: 'Guidance Line name',
  customRefLineDeleteAlert: 'Are you sure you want to delete {refLineName}',
  customRefLineDeleteUnknownName: 'This Guidance Line',
  customRefLineDeleteKnownName: 'Guidance Line "{refLineName}".',
  customRefLineDeleteError: 'Failed to delete Guidance Line',

  customThunderstormWithLightRain: 'Thunderstorm with light rain',
  customThunderstormWithRain: 'Thunderstorm with rain',
  customThunderstormWithHeavyRain: 'Thunderstorm with heavy rain',
  customThunderstormWithLightDrizzle: 'Thunderstorm with light drizzle',
  customThunderstormWithDrizzle: 'Thunderstorm with drizzle',
  customThunderstormWithHeavyDrizzle: 'Thunderstorm with heavy drizzle',
  customThunderstormWithHail: 'Thunderstorm with Hail',
  customLightDrizzle: 'Light Drizzle',
  customDrizzle: 'Drizzle',
  customHeavyDrizzle: 'Heavy Drizzle',
  customLightRain: 'Light Rain',
  customModerateRain: 'Moderate Rain',
  customHeavyRain: 'Heavy Rain',
  customFreezingRain: 'Freezing rain',
  customLightShowerRain: 'Light shower rain',
  customShowerRain: 'Shower rain',
  customHeavyShowerRain: 'Heavy shower rain',
  customLightSnow: 'Light snow',
  customSnow: 'Snow',
  customHeavySnow: 'Heavy Snow',
  customMixSnowRain: 'Mix snow/rain',
  customSleet: 'Sleet',
  customHeavySleet: 'Heavy sleet',
  customSnowShower: 'Snow shower',
  customHeavySnowShower: 'Heavy snow shower',
  customFlurries: 'Flurries',
  customMist: 'Mist',
  customSmoke: 'Smoke',
  customHaze: 'Haze',
  customSandDust: 'Sand/dust',
  customFog: 'Fog',
  customFreezingFog: 'Freezing Fog',
  customClearSky: 'Clear sky',
  customFewClouds: 'Few clouds',
  customScatteredClouds: 'Scattered clouds',
  customBrokenClouds: 'Broken clouds',
  customOvercastClouds: 'Overcast clouds',
  customUnknownPrecipitation: 'Unknown Precipitation',
  customWeatherInfoTitle: 'Weather information',
  customWeatherDescriptionTitle: 'Weather',
  customWindSpeedTitle: 'Wind speed',
  customTemperatureTitle: 'Temperature',
  customRelativeHumidityTitle: 'Humidity',
  customPrecipitationTitle: 'Precipitation',
  customNumOfSatellites: 'Number of satellites',
  customGnssStatus: 'GNSS status',
  customLeftRightMisalignment: 'Misalignment',
  customAzimuthShift: 'Azimuth shift',
  customGradient: 'Gradient',
  customTimeOfAcquisition: 'Time of acquisition',
  customWorkOverview: 'Work overview',
  customImageStorage: 'Save image',
  customMapGaugeDescriptionNone: 'The fill of the work without colour coding is displayed',
  customMapGaugeDescriptionHeight: 'The height difference of the work is displayed in different colours',
  customMapGaugeDescriptionSpeed: 'The speed of your work is displayed in different colours',
  customMapGaugeDescriptionNumOfSatellites: 'The number of satellites at work is shown in different colours',
  customMapGaugeDescriptionGnssStatus: 'Colour-coded display of GNSS status at work',
  customMapGaugeDescriptionLeftRightMisalignment:
    'Left/right deviations from the guidance during operation are shown in different colours',
  customMapGaugeDescriptionAzimuthShift: 'Colour-coded display of misalignment with guidance at work',
  customMapGaugeDescriptionGradient:
    'The working inclination is displayed in different colours (G2, GMiniR and Gmini only).',
  customWeathercomTornado: 'Tornado',
  customWeathercomTropicalStorm: 'Tropical Storm',
  customWeathercomHurricane: 'Hurricane',
  customWeathercomStrongStorms: 'Strong Storms',
  customWeathercomThunderstorms: 'Thunderstorms',
  customWeathercomRainSnow: 'Rain Snow',
  customWeathercomRainSleet: 'Rain Sleet',
  customWeathercomWintryMix: 'Wintry Mix',
  customWeathercomFreezingDrizzle: 'Freezing Drizzle',
  customWeathercomDrizzle: 'Drizzle',
  customWeathercomFreezingRain: 'Freezing Rain',
  customWeathercomShowers: 'Showers',
  customWeathercomRain: 'Rain',
  customWeathercomFlurries: 'Flurries',
  customWeathercomSnowShowers: 'Snow Showers',
  customWeathercomBlowingDriftingSnow: 'Blowing Drifting Snow',
  customWeathercomSnow: 'Snow',
  customWeathercomHail: 'Hail',
  customWeathercomSleet: 'Sleet',
  customWeathercomBlowingDustSandstorm: 'Blowing Dust Sandstorm',
  customWeathercomFoggy: 'Foggy',
  customWeathercomHaze: 'Haze',
  customWeathercomSmoke: 'Smoke',
  customWeathercomBreezy: 'Breezy',
  customWeathercomWindy: 'Windy',
  customWeathercomFrigidIceCrystals: 'Frigid Ice Crystals',
  customWeathercomCloudy: 'Cloudy',
  customWeathercomMostlyCloudy: 'Mostly Cloudy',
  customWeathercomPartlyCloudy: 'Partly Cloudy',
  customWeathercomClear: 'Clear',
  customWeathercomSunny: 'Sunny',
  customWeathercomFairMostlyClear: 'Fair Mostly Clear',
  customWeathercomFairMostlySunny: 'Fair Mostly Sunny',
  customWeathercomMixedRainandHail: 'Mixed Rain and Hail',
  customWeathercomHot: 'Hot',
  customWeathercomIsolatedThunderstorms: 'Isolated Thunderstorms',
  customWeathercomScatteredThunderstorms: 'Scattered Thunderstorms',
  customWeathercomScatteredShowers: 'Scattered Showers',
  customWeathercomHeavyRain: 'Heavy Rain',
  customWeathercomScatteredSnowShowers: 'Scattered Snow Showers',
  customWeathercomHeavySnow: 'Heavy Snow',
  customWeathercomBlizzard: 'Blizzard',
  customWeathercomNotAvailable: 'Not Available',
  customSharedMountPointSetting: 'Mount point settings',
  customSharedMountPointSettingTitle:
    'Set the mount point for the RTK reference station to be shared within the organisation.',
  customSharedMountPoint: 'Shared mount points',
  customMountPoint: 'Mounting points',
  customStatus: 'Status',
  customNotSet: 'Not set',
  customSelectMountPoint: 'Select mount point',
  customUnsharedMountPoint: 'Unshared',
  customSelectMountPointTitle: 'Please select a mount point to share',
  customSharedMountPointRemarks1:
    'Mount points are issued when AgriBus-GMiniR is set as a reference station using the AgriBus-GTools application. If you are using a reference station from another manufacturer, please apply using the link below.',
  customSharedMountPointRemarks2: 'Click here to apply',
  customOnline: 'Online',
  customOffline: 'Offline',
  customNotIssued: 'Not issued',
  customSetItUp: 'Weve set it up',
  customDeActivated: 'Deactivated.',
  customType: 'Type',
  customCropIsNotRegistered: 'The crop is not registered',
  customNameNotRegistered: 'Name Unregistered',

  customGoToPayerManager: 'Open admin panel',
  customPaymentInfo: 'Payment information',
  customProjectInfo: 'Project information',
  customAddProject: 'Add project',
  customAddProjectRemarks: 'Please specify the project name and the administrators email address',
  customProjectName: 'Project name',
  customProjectAdminMailAddress: 'Administrators email address',
  customStop: 'Stop',
  customStopDialogText: 'Do you want to delete the selected project?',
  customDone: 'Its done!',
  customUpdateDay: 'Update Day',
  customAdminName: 'Managers name',
  customMaxQuantity: 'Maximum number of people',
  customaddProjectSuccess: 'Your project has now been added.',
  customPlantingShowPast: 'Show past plantings',
  customPlantingHidePast: 'Hide past plantings',
  customPlantingCropDisplayName: 'Crop display name',
  customPlantingCropVarietyName: 'Variety name',
  customPlantingSeason: 'Growing season',
  customPlantingSeasonStartDate: 'Start date (required)',
  customPlantingSeasonEndDate: 'End date',
  customPlantingAddCropOption: 'Add crop option',
  customPlantingRemoveCropOption: 'remove crop option',
  customPlantingCropSelectionRequiredError: 'Must be selected. If none apply, please select "Other".',
  customPlantingOtherCropSelectionRequiredError: 'Must be entered if "Other" is selected',
  customPlantingDeleteConfirmationMessage:
    "Are you sure you want to delete {plantingName}? (Associated data will also be deleted)'",
  customPlantingFieldSelectionHint: 'If the field name has not been set, it will not appear in the list here',

  customTaskDeleteMessage: 'Are you sure you want to delete the work you have selected?',
  customTaskDeleteFailure: 'Failed to delete the selected work',
  customTaskDeleteSucceed: 'You have successfully deleted the selected work',

  customErrorStartDateRequired: 'Start date is required',
  customErrorFieldRequired: 'Plots are essential',

  customAlreadyExistingUser:
    'You have already registered your email address. Please use an unregistered email address.',

  customNowProgressRateTitle: 'Work progress',
  customNowProgressRateNotField: 'No relevant plots',

  customStandardSubscribeErrorMessage:
    'Your subscription purchase has failed. Please check the information you have entered again.',
  customStripeCouponText1: 'Click here to redeem your voucher',
  customStripeCouponText2: 'Click here for voucher code',

  customUpdatePolygonFailure: 'I have failed to update my field.',

  customMultiPolygonImportError:
    'Data containing MultiPolygons, which must be converted to Polygons as MultiPolygons are not supported.',

  customSimpleSignUpAndSignInError: 'There is a problem with your email address or password. Please check.',
  customNewPasswordValidationError: 'At least one lowercase letter and one number are required.',

  // 2022.12.08
  customSelectPlanSelectPaymentMethodText: 'Select a payment method',
  customCardInfoHasNotBeenEnteredError: 'Please enter your credit card information',
  customNoPaymentMethodSeletedError: 'No payment method selected',
  customFreeDashBoardText1:
    'A subscription to the paid plan (AgriBus Professional) is required to log in to AgriBus-Web.',
  customFreeDashBoardText2: 'For more informatio ',
  customFreeDashBoardText3: 'Notice',
  customFreeDashBoardText4: '.',
  customContractPlanTitle: 'Contract Plan',
  customComparePlansText: 'Compare Plans',
  customUpgradeToPlusText: 'Upgrade to Plus',
  customDowngradeToPlusText: 'Downgrade to Plus',
  customUpgradeToProfessionalText: 'Upgrade to AgriBus Professional',
  customBillingBillingText1: 'Canceled - automatically converted to a Free plan when it expires.',
  customUpgradeConfirematoinText: 'I will upgrade to AgriBus Professional. Is this OK?',
  customDowngradeConfiremationText: 'I will downgrade to Plus. Is this OK?',
  customBankTransfer: 'bank transfer',
  customHome: 'Home',
  customBillingMessageSubscribeGoogle:
    'You are currently subscribed to the Google Play Store, please upgrade/downgrade your subscription in the Google Play Store',
  customInvoiceReceiptAddresseeTitle: 'Invoice/Receipt Address',
  customChangeAddresseeBtnText: 'Change the address',
  customBillingEmailAddressTitle: 'Billing Email Address',
  customChangeBillingEmailAddressText: 'Change your billing email address',
  customCannotDowngradeText: 'Bank transfers cannot be downgraded to Plus',
  customChangePaymentMethodsToCard: 'Change to credit card payment',
  customChangePaymentMethodsToCustomerBalance: 'Change to bank transfer',
  customChangePaymentMethodToSendInvoiceText: 'May I change the payment method to bank transfer?',
  customMapGaugeDescriptionColorCodedFill:
    'If you have used the app to fill in by color, a color-coded work history will be displayed.',
  customColorCodeFill: 'Fill by color',
  customSelectDefaultIconTitle: 'Please select an icon',
  customImportLimitMessage: 'The maximum number of imports is {limit}.',
  customPresetIcon: {
    title: 'Preset',
    description: 'You can choose from 6 different presets.',
    btnText: 'Select from presets',
  },
  customBulkDeleteCheckboxText: 'bulk deletion',
  customBulkDeleteDialogText: 'May I perform a bulk deletion?',
  customPerimeter: 'Perimeter',
  feed: {
    menu: 'Feed',
    title: 'News Feed',
    description: 'Daily regional farm-activity statistics (anonymized) and crop-region updates.',
    yourArea: 'Activity in your area (~33 km)',
    areaFromFields: 'Detected from your fields',
    widerArea: 'Wider area (~55 km)',
    national: 'Nationwide activity',
    daily: 'Yesterday',
    weekly: 'Last 7 days',
    monthly: 'Last 28 days',
    vsNormal: 'vs normal',
    vsLastYear: 'vs last year',
    noData: 'Not enough data in this area (too few nearby operations).',
    noAreaHint: 'Register your fields to see statistics for your area.',
    nationalFallback: 'Nationwide statistics are shown below.',
    upsell: 'Paid plans add the daily and 28-day windows, plus the wider ~55 km view.',
    monitorTitle: 'Crop monitor weekly',
    monitorActive: 'Observation pattern active',
    monitorNone: 'No observation pattern',
    toMarketInsights: 'Open Market Insights',
    loadError: 'Could not load the feed. Please try again later.',
    disclaimer: 'Regional activity is anonymized statistics, not an evaluation of any individual farm.',
    kindNews: 'News',
    kindPr: 'PR',
    readMore: 'Read more',
    entryDaily: 'Work activity on {date}',
    entryWeekly: 'Weekly summary (through {date})',
    areaC3: 'Your area',
    areaC5: 'Wider area',
    areaJp: 'Nationwide',
    historyTitle: 'Past trend',
    kindSignal: 'Signal',
    shareTitle: 'Share to feed',
    share: 'Share',
    shareVisibility: 'Visibility',
    visFollowers: 'Followers only',
    visNeighborhood: 'Neighborhood',
    visPublic: 'Public',
    shareRoute: 'Show work path',
    shareExact: 'Also share exact location (map background)',
    statTime: 'Time',
    statDistance: 'Distance',
    statArea: 'Area',
    statWidth: 'Width',
    statSpeed: 'Speed',
    statGnss: 'GNSS',
    shareComment: 'Comment',
    shareSubmit: 'Share',
    sharePosted: 'Shared',
    shareFailed: 'Could not complete. Please try again later.',
    consentNote:
      'Your post is shown to users in the selected visibility. Location is shown only as an approximate area (about 11 km).',
    consentLabel: 'I agree to the sharing terms (Article 15-2)',
    postDelete: 'Delete',
    postDeleted: 'Post deleted',
    postDeleteConfirm: 'Delete this post?',
    report: 'Report',
    reportTitle: 'Report post',
    reportConfirm: 'Report this post to the operator?',
    reportReason: 'Reason (optional)',
    reportDone: 'Report sent. Thank you',
    visPrivate: 'Only me',
    followRequested: 'Requested',
    followAccept: 'Accept',
    followDecline: 'Decline',
    followAccepted: 'Follow request accepted',
    unfollow: 'Unfollow',
    unfollowConfirm: 'Unfollow this user?',
    connectionsHint: 'Send follow requests from feed posts. Once accepted, you can see followers-only posts',
    sharePhotos: 'Add photos (up to 4)',
    sharePhotosHint: 'Location metadata (EXIF) is removed automatically',
    snsShare: 'Share',
    copyLink: 'Copy link',
    linkCopied: 'Link copied',
    shareOther: 'Other apps',
    instagramSaved: 'Card image saved. Post it from the Instagram app',
    manualRecords: 'Manual records',
    addManualRecord: 'Add manual record',
    manualChip: 'Manual',
    recordStart: 'Start time',
    recordEnd: 'End time',
    recordMemo: 'Memo',
    recordDuration: 'Duration (min)',
    recordCreated: 'Record added',
    recordDeleteConfirm: 'Delete this record?',
    noManualRecords: 'No manual records yet',
    poiRecords: 'Points of interest',
    addPoi: 'Add point of interest',
    poiTitle: 'Title',
    poiMapHint: 'Click the map to set the location. If not set, photo location data is used',
    noPoiRecords: 'No points of interest yet',
    map: 'Map',
    mapLayers: 'Layers',
    editMode: 'Edit mode',
    selected: 'Selected',
    mergeSave: 'Save merged',
    clipDraw: 'Draw clip area',
    saveAsField: 'Save planted area as field',
    workWidthM: 'Working width (m)',
    workName: 'Name',
    workSaved: 'Derived record saved',
    derivedRecords: 'Derived records',
    derivedChip: 'Derived',
    derivedDeleteConfirm: 'Delete this derived record?',
    saveRangeAsWork: 'Save selected range as derived record',
    clipByField: 'Clip by field',
    showOnMap: 'Show on map',
    editRange: 'Edit range',
    trajectoryChip: 'GPS',
    derivedRecordsDescription:
      'Work records paired 1:1 with each trajectory. Edited records (merge/clip/range) and manual records are listed here too',
    spatialEdit: 'Clip / Save as field',
    vraTitle: 'VRA Map',
    vraDescription: 'Generate variable-rate application zone maps from satellite vegetation indices',
    vraGenerate: 'Generate new map',
    vraIndex: 'Vegetation index',
    vraGridSize: 'Grid (m)',
    vraDirection: 'Direction (deg)',
    vraCloudPct: 'Max cloud (%)',
    vraImages: 'Images used',
    vraFailed: 'Generation failed. There may be no cloud-free imagery in the selected period',
    saveFailed: 'Failed to save',
    mapSetGenerated: 'Generation completed',
    fieldValidFromDate: 'Valid from: {date}',
    fieldDeleteLinked: '{fieldName} cannot be deleted because it is linked to the following data.',
    fieldDeleteLinkedTasks: 'Work records: {count}',
    fieldDeleteLinkedSets: 'Field sets: {names}',
    fieldDeleteLinkedHint: 'To delete it, first remove the linked work records and field sets.',
    elevSource: 'Source',
    elevSourceDem: 'Satellite (DEM)',
    elevSourceGnss: 'Work history (GNSS)',
    elevCenter: 'Color center',
    elevCenterMean: 'Mean',
    elevCenterMedian: 'Median',
    elevCenterValue: 'Center elevation',
    elevCustom: 'Custom',
    elevRange: 'Color range',
    elevRangeWidth: 'Range width',
    elevContour: 'Contour lines',
    zoneBands: 'Zones',
    zonePalette: 'Color scheme',
    paletteHue: 'HSI (green→yellow→red)',
    paletteYlgn: 'Yellow→Green',
    paletteGnrd: 'Green→Red',
    reclassifyTitle: 'Change zones/colors (no regeneration)',
    reclassifyApply: 'Apply reclassification',
    followByEmail: 'Follow request by email address',
    emailUserNotFound: 'No user found for this email address',
    followRequestSent: 'Follow request sent',
    eventSettingsTitle: 'Feed settings (auto events)',
    eventSettingsVisibility: 'Event visibility',
    eventSettingsLocation: 'Location visibility',
    eventSettingsSnsStrip: 'Strip exact location when sharing to SNS (default)',
    eventSettingsPrefs: 'Events posted to your feed',
    locHidden: 'Hidden',
    locApprox: 'Approximate (~10 km grid)',
    locExact: 'Include exact location',
    event_work_start: 'Work started',
    event_work_end: 'Work finished',
    event_field_enter: 'Entered field',
    event_field_exit: 'Left field',
    event_poi_added: 'POI added',
    event_vra_map_added: 'VRA map added',
    event_elevation_map_added: 'Height map added',
    event_refline_added: 'Guidance line added',
    event_field_added: 'Field added',
    event_field_set_added: 'Field set added',
    event_work_start_text: 'started working ({name})',
    event_work_end_text: 'finished working ({name})',
    event_field_enter_text: 'entered field \u201c{name}\u201d',
    event_field_exit_text: 'left field \u201c{name}\u201d',
    event_poi_added_text: 'added POI \u201c{name}\u201d',
    event_vra_map_added_text: 'created VRA map \u201c{name}\u201d',
    event_elevation_map_added_text: 'created height map \u201c{name}\u201d',
    event_refline_added_text: 'added guidance lines ({name})',
    event_field_added_text: 'added field \u201c{name}\u201d',
    event_field_set_added_text: 'created field set \u201c{name}\u201d',
    vraNameAuto: 'Name (blank = auto: field + index + date)',
    eventPrefOff: 'Do not post',
    visEditTitle: 'Change visibility',
    visEditLocationExact: 'Show exact location (map background)',
    visEditRemoveLocation: 'Remove exact location',
    visEditPublicNote: 'Exact location is automatically excluded for public posts',
    consentRequiredToShare: 'Sharing requires consent to the sharing terms. Enable sharing from a regular post first',
    elevGnssFailed:
      'Height calculation failed. No work history (GNSS elevations) matches the filters, or it is still processing. Try relaxing the GNSS status filter or date range',
    elevDescription:
      'Generate field height maps from GNSS elevations in your work history (RTK recommended). Satellite elevation data (DEM) is also available when no work history exists. Syncs to NAVI like VRA maps',
    fieldValidUntil: 'Valid until: {date}',
    mapSetGeneratedWithCount: 'Generated {created} / failed {failed} (existing maps for the same fields are replaced)',
    vraGenerating: 'Analyzing satellite imagery...',
    vraObsDate: 'Observation date',
    vraPeriodMean: 'Period mean',
    vraLimitReached: 'Generation limit reached (Free: 3 in total, paid plans: 10 per day)',
    vraExport: 'Export ISOXML',
    vraModeGrid: 'Mesh (grid)',
    vraModePolygon: 'Polygon',
    vraRate: 'Application rate (kg/ha)',
    vraCellSize: 'Cell size (m)',
    vraEditMap: 'Edit',
    mapSets: 'Field sets',
    mapSetDescription:
      'Group fields with a filter (validity period, crop, name). Used for bulk VRA map generation and more',
    mapSetCreate: 'Create field set',
    fieldSetEmpty: 'No field sets yet',
    mapSetTargetDate: 'Target date',
    mapSetCrop: 'Crop',
    mapSetNameContains: 'Field name (contains)',
    mapSetMemoContains: 'Memo (contains)',
    mapSetPreviewCount: 'Matching fields',
    mapSetGenerate: 'Generate/Update',
    mapSetFields: 'Fields',
    mapSetLastGenerated: 'Last generated',
    fieldAttrsTitle: 'Field attributes (validity & crop)',
    fieldValidFrom: 'Valid from (blank = unlimited)',
    fieldValidTo: 'Valid to (blank = unlimited)',
    mapSetNoMatch: 'No fields match the filter',
    mapSetDeleteConfirm: 'Delete this field set and the VRA maps generated from it?',
    trajectories: 'Trajectories',
  },
  marketInsights: {
    menu: 'Market Insights',
    title: 'Market Insights (AgriBus-DWH)',
    description:
      'Check daily field-work progress and market observations for major global soybean and wheat regions. A member benefit: anonymized statistics built from member work data, delivered as information useful for decisions such as when to sell.',
    soybeanDescription: 'Crop conditions and market observation signals for soybean regions in Brazil and the US',
    wheatDescription: 'Crop conditions and market observation signals for wheat regions',
    open: 'Open',
    upsell: 'Market Insights is a benefit for paid-plan members. Subscribe to a paid plan to view it at no extra cost.',
    memberNote:
      'While viewing as a member, a badge appears at the top left of the monitor. This information is not investment advice.',
  },
}
